import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent{

  myCarinfo = [{
    
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 take",
    Price:5000
  },
  
  {
  
  'name':"Papu",
  'stock':12,
  'discriptions':"This is Aswosome product 2",
  'Price':200
  },
  {
    
    'name':"Papu",
    'stock':12,
    'discriptions':"This is Aswosome product 2",
    'Price':1500
    },

  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    'Price':703
  },
  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    'Price':800
  },
  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    Price:100
  

  }];

  

}
